export default __webpack_public_path__ + "static/media/Gilroy-ExtraBold.59a66eb8.ttf";